import React from 'react'
import { makeStyles } from '@mui/styles'
import { useSelector } from 'react-redux'

import lang from '@/lang'

import Logo from '@assets/images/onboarding/logo_desktop.svg'

import Footer from './sidebarFooter'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'

const Indicator = ({ active }) => {
  const classes = useStyles({ active })

  return (
    <span className={classes.indicator} />
  )
}

const Sidebar = ({ hideStepper = false }) => {
  const { step, totalSteps } = useSelector(state => state.wizard.config)
  const classes = useStyles()

  return (
    <div className={classes.sidebar}>
      <div className={classes.componentContainer}>
        <header className={classes.logo}><SVGIcon height="57px" width="160px" svg={Logo} /></header>
        {!hideStepper && <div>
          <div>{lang.onboarding.general.stepper.replace('{current}', step + 1).replace('{totalSteps}', totalSteps + 1)}</div>
          <div className={classes.indicators}>
            {[...Array(totalSteps + 1).fill(undefined)].map((useless, index) => <Indicator key={`indicator_${index}`} active={index === step} />)}
          </div>
        </div>}
      </div>
      <Footer />
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  sidebar: {
    display: 'none',
    position: 'relative',
    minWidth: 220,
    maxWidth: 220,
    backgroundColor: theme.sidebarColor,
    padding: 30,
    color: '#fff',
    '@media (min-width: 800px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  componentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    overflow: 'hidden',
  },
  logo: {
    marginTop: 10,
  },
  indicators: {
    marginBottom: 25,
    marginTop: 10,
    textAlign: 'center',
  },
  indicator: ({ active }) => ({
    display: 'inline-block',
    width: 12,
    height: 12,
    border: `1px solid ${active ? theme.primary : theme.white}`,
    background: active ? theme.primary : 'transparent',
    borderRadius: '50%',
    margin: '0 3px',
  }),
}))

export default Sidebar
